var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex justify-content-center" }, [
    _c(
      "a",
      {
        staticClass: "mr-3",
        attrs: { href: _vm.termsAndConditionsLink, target: "_blank" }
      },
      [_vm._v("Terms and Conditions")]
    ),
    _c("a", { attrs: { href: _vm.privacyPolicyLink, target: "_blank" } }, [
      _vm._v("Privacy Policy")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }